import { Component, OnInit } from '@angular/core'

@Component({
  selector: 'vb-widgets-general-24v1',
  templateUrl: './24v1.component.html',
})
export class VbGeneral24v1Component implements OnInit {
  constructor() {}
  ngOnInit() {}
}
